// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Calendar_title__BOTEl {
  margin-top: 50px;
  width: 100%;
  text-align: center;
  font-size: 28px;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  color: #4d4d4d;
}
.Calendar_col__6qOLn {
  width: 250px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.Calendar_row__qCSaC {
  display: flex;
  justify-content: center;
  gap: 40;
}
.Calendar_label__uHf8i {
  font-size: 16;
  font-family: "Inter";
  font-weight: 600;
  color: "#5F6D7E";
}
.Calendar_events__JoZv- {
  height: 100%;
  padding: 4px;
  border-radius: 4px;
  text-transform: capitalize;
  text-align: center;
  align-items: center;
  display: flex;
}
.Calendar_time__5oPRT {
  font-size: 12px;
  font-weight: 500;
  color: #71717a;
  font-family: "Inter", sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/scenes/calendarIpd/components/Calendars/Calendar.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,OAAO;AACT;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC","sourcesContent":[".title {\n  margin-top: 50px;\n  width: 100%;\n  text-align: center;\n  font-size: 28px;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 600;\n  color: #4d4d4d;\n}\n.col {\n  width: 250px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.row {\n  display: flex;\n  justify-content: center;\n  gap: 40;\n}\n.label {\n  font-size: 16;\n  font-family: \"Inter\";\n  font-weight: 600;\n  color: \"#5F6D7E\";\n}\n.events {\n  height: 100%;\n  padding: 4px;\n  border-radius: 4px;\n  text-transform: capitalize;\n  text-align: center;\n  align-items: center;\n  display: flex;\n}\n.time {\n  font-size: 12px;\n  font-weight: 500;\n  color: #71717a;\n  font-family: \"Inter\", sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `Calendar_title__BOTEl`,
	"col": `Calendar_col__6qOLn`,
	"row": `Calendar_row__qCSaC`,
	"label": `Calendar_label__uHf8i`,
	"events": `Calendar_events__JoZv-`,
	"time": `Calendar_time__5oPRT`
};
export default ___CSS_LOADER_EXPORT___;
